import { useReducer } from 'react'

function mergeReducer(state, update) {
    return { ...state, ...update }
}

export function useMergeState(initState) {
    return useReducer(mergeReducer, initState || {})
}
